/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Table, FlexboxGrid } from 'rsuite';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela';
import api from '~/services/api';
import {
  CelulaEditavel,
  CelulaAcao,
} from '~/components/Celulas/components/CelulaEditavel';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';

const { HeaderCell, Column, Cell } = Table;

function montarLista(parametros) {
  return [
    {
      id: 'distancia',
      chave: 'distancia_maxima_sugestao_km',
      descricao: 'Distância máxima para sugestões de vagas (km)',
      valor: parametros.distancia_maxima_sugestao_km,
    },
    {
      id: 'dias_senha',
      chave: 'dias_expiracao_senha_adm',
      descricao: 'Dias para troca obrigatória da senha do administrador',
      valor: parametros.dias_expiracao_senha_adm,
    },
  ];
}

function ConfiguracoesAdministracao() {
  const [dados, setDados] = useState({
    lista: [],
    listaInicial: [],
  });
  const [carregando, setCarregando] = useState(true);

  async function buscarConfiguracoes() {
    try {
      setCarregando(true);
      const resposta = await api.get('parametros-sistema');
      const lista = montarLista(resposta.data);

      setDados({
        lista,
        listaInicial: lista.map(item => ({ ...item })),
      });
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    buscarConfiguracoes();
  }, []);

  function alterarTextoCelula(id, key, value) {
    const nextData = [...dados.lista];
    const item = nextData.find(configuracao => configuracao.id === id);

    if (!item) {
      return;
    }

    item[key] = value;
    setDados({ ...dados, lista: nextData });
  }

  async function alterarEstadoCelula(id) {
    const novaLista = [...dados.lista];
    const item = novaLista.find(configuracao => configuracao.id === id);
    const itemInicial = dados.listaInicial.find(configuracao => configuracao.id === id);

    if (!item || !itemInicial) {
      return;
    }

    const valorAtual = Number(item.valor);
    const valorInicial = Number(itemInicial.valor);

    if (item.status === 'EDIT' && valorAtual !== valorInicial) {
      try {
        setCarregando(true);
        await api.put('parametros-sistema', {
          [item.chave]: valorAtual,
        });
        toast.success('Configurações atualizadas com sucesso');
        await buscarConfiguracoes();
      } catch (error) {
        toast.error(error.message);
      } finally {
        setCarregando(false);
      }
      return;
    }

    item.status = item.status ? null : 'EDIT';
    setDados({ ...dados, lista: novaLista });
  }

  return (
    <Container>
      <h2>Configurações</h2>
      <FlexboxGrid style={{ width: '100%' }}>
        <TabelaSemPaginacao carregando={carregando} dados={dados.lista}>
          <Column resizable flexGrow={1}>
            <HeaderCell>Parâmetro</HeaderCell>
            <Cell dataKey="descricao" />
          </Column>

          <Column resizable width={220}>
            <HeaderCell>Valor</HeaderCell>
            <CelulaEditavel dataKey="valor" onChange={alterarTextoCelula} />
          </Column>

          <Column resizable width={140}>
            <HeaderCell>Editar</HeaderCell>
            <CelulaAcao dataKey="id" onClick={alterarEstadoCelula} />
          </Column>
        </TabelaSemPaginacao>
      </FlexboxGrid>
    </Container>
  );
}

export default ConfiguracoesAdministracao;
